import axios from "axios";
import constants from "@/config/constants";

function initialState() {
    return {
        all: [],
        loading: false,
    }
}

const getters = {
    all:         state => state.all,
    loading:       state => state.loading,
}

const actions = {
    fetchData({ commit }) {
        commit('setLoading', true)

        return axios.get(constants.API_AUTH_URL + '/api/v1/permissions')
            .then(response => {
                commit('setAll', response.data.data)
            })
            .catch(error => {
                const message = error.response.data.message || error.message
                console.log(message)
            })
            .finally(() => {
                commit('setLoading', false)
            })
    },
    destroyData({ commit, state }, id) {
        axios.delete(constants.API_AUTH_URL + '/api/v1/permissions/' + id)
            .then(() => {
                commit('setAll', state.all.filter((item) => {
                    return item.id != id
                }))
            })
            .catch(error => {
                const message = error.response.data.message || error.message
                console.log(message)
            })
    },
    resetState({ commit }) {
        commit('resetState')
    }
}

const mutations = {
    setAll(state, items) {
        state.all = items
    },
    setLoading(state, loading) {
        state.loading = loading
    },
    resetState(state) {
        // eslint-disable-next-line no-unused-vars
        state = Object.assign(state, initialState());
    }
}

export default {
    namespaced: true,
    state: initialState,
    getters,
    actions,
    mutations
}
